import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12, default as _styled13, default as _styled14, default as _styled15, default as _styled16, default as _styled17, default as _styled18, default as _styled19, default as _styled20, default as _styled21, default as _styled22, default as _styled23, default as _styled24, default as _styled25, default as _styled26 } from "styled-components";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { Grid } from "~/features/ui/grid";
import { Link } from "~/features/ui/link";
import { Logo } from "~/features/ui/logo";
import { FooterCopyright } from "~/features/app/app-footer/footer-copyright";
import { Wrap } from "~/features/ui/wrap";
import { Pattern, type PatternType } from "~/features/app/pattern";
import { FooterDotGrid } from "~/features/app/app-footer/footer-dot-grid";
type Props = {
  isPageHighlighted?: boolean;
  footerPattern?: PatternType;
  socials: React.ReactNode;
  link: React.ReactNode;
  additionalLinks: React.ReactNode;
  newsletter: React.ReactNode;
  links: React.ReactNode;
  bottomLinks: React.ReactNode;
};
export function AppFooter(props: Props) {
  const {
    isPageHighlighted = false,
    footerPattern = "none",
    socials,
    link,
    additionalLinks,
    newsletter,
    links,
    bottomLinks
  } = props;
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  const surfaceBg = isPageHighlighted ? {
    "backgroundColor": "var(--white-static)"
  } : themeStyle.background;
  return <_StyledFooter $_css={[{
    "borderTopWidth": "1px"
  }, themeStyle.border, surfaceBg, footerPattern !== "none" && {
    "position": "relative"
  }]}>
      {footerPattern !== "none" && <_StyledDiv $_css2={[{
      "pointerEvents": "none",
      "position": "absolute",
      "inset": "0",
      "zIndex": "0"
    }, isPageHighlighted ? {
      "backgroundColor": "var(--white-static)"
    } : {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(239 239 246 / var(--tw-bg-opacity))"
    }]}>
          <Pattern pattern={footerPattern} />
        </_StyledDiv>}
      <Wrap mode="light">
        <_StyledDiv2>
          <_StyledGrid $_css3={[{
          "> :not([hidden]) ~ :not([hidden])": {
            "--tw-divide-x-reverse": "0",
            "borderRightWidth": "calc(1px * var(--tw-divide-x-reverse))",
            "borderLeftWidth": "calc(1px * calc(1 - var(--tw-divide-x-reverse)))"
          }
        }, themeStyle.border]}>
            <_StyledDiv3>
              <_StyledDiv4 $_css4={[{
              "position": "relative",
              "zIndex": "10",
              "display": "flex",
              "height": "13.6rem",
              "alignItems": "center",
              "justifyContent": "center",
              "borderBottomWidth": "1px",
              "paddingLeft": "2.4rem",
              "paddingRight": "2.4rem"
            }, surfaceBg, themeStyle.border]}>
                <_StyledLink href={process.env.NEXT_PUBLIC_URL} aria-label="Ouster">
                  <Logo logo="full" variant="dark" />
                </_StyledLink>
              </_StyledDiv4>
              <_StyledDiv5 $_css5={[{
              "position": "relative",
              "zIndex": "10",
              "display": "flex",
              "minHeight": "0",
              "flex": "1 1 0%",
              "flexDirection": "column"
            }, surfaceBg]}>
                <_StyledFooterDotGrid />
                <_StyledDiv6>{socials}</_StyledDiv6>
              </_StyledDiv5>
            </_StyledDiv3>
            <_StyledDiv7 $_css6={[{
            "position": "relative",
            "zIndex": "10",
            "gridColumn": "span 9 / span 9"
          }, surfaceBg]}>
              <_StyledDiv8 $_css7={[{
              "display": "flex",
              "height": "13.6rem",
              "alignItems": "center",
              "justifyContent": "space-between",
              "columnGap": "8rem",
              "borderBottomWidth": "1px",
              "paddingLeft": "8rem",
              "paddingRight": "8rem"
            }, themeStyle.border]}>
                {link}
                {additionalLinks}
              </_StyledDiv8>
              <_StyledDiv9 $_css8={[{
              "borderBottomWidth": "1px"
            }, themeStyle.border]}>{newsletter}</_StyledDiv9>
              <_StyledDiv10>{links}</_StyledDiv10>
            </_StyledDiv7>
          </_StyledGrid>
          <_StyledGrid2 $_css9={[{
          "position": "relative",
          "zIndex": "10",
          "alignItems": "center",
          "> :not([hidden]) ~ :not([hidden])": {
            "--tw-divide-x-reverse": "0",
            "borderRightWidth": "calc(1px * var(--tw-divide-x-reverse))",
            "borderLeftWidth": "calc(1px * calc(1 - var(--tw-divide-x-reverse)))"
          },
          "borderTopWidth": "1px"
        }, themeStyle.border, surfaceBg]}>
            <_StyledDiv11>
              <FooterCopyright />
            </_StyledDiv11>
            <_StyledDiv12>{bottomLinks}</_StyledDiv12>
          </_StyledGrid2>
        </_StyledDiv2>
        <_StyledDiv13 $_css10={[{
        "display": "block",
        "> :not([hidden]) ~ :not([hidden])": {
          "--tw-divide-y-reverse": "0",
          "borderTopWidth": "calc(1px * calc(1 - var(--tw-divide-y-reverse)))",
          "borderBottomWidth": "calc(1px * var(--tw-divide-y-reverse))"
        },
        "@media (min-width: 1024px)": {
          "display": "none"
        }
      }, {
        "position": "relative",
        "zIndex": "10"
      }, surfaceBg, themeStyle.border]}>
          <_StyledDiv14 $_css11={[{
          "display": "flex",
          "height": "7.2rem",
          "> :not([hidden]) ~ :not([hidden])": {
            "--tw-divide-x-reverse": "0",
            "borderRightWidth": "calc(1px * var(--tw-divide-x-reverse))",
            "borderLeftWidth": "calc(1px * calc(1 - var(--tw-divide-x-reverse)))"
          }
        }, themeStyle.border]}>
            <_StyledDiv15>
              <_StyledLink2 href={process.env.NEXT_PUBLIC_URL} aria-label="Ouster">
                <Logo logo="mark" variant="dark" />
              </_StyledLink2>
            </_StyledDiv15>
            <_StyledDiv16>{link}</_StyledDiv16>
          </_StyledDiv14>
          <_StyledDiv17>{additionalLinks}</_StyledDiv17>
          <div>{newsletter}</div>
          <div>{links}</div>
          <_StyledDiv18>{socials}</_StyledDiv18>
          <_StyledDiv19>{bottomLinks}</_StyledDiv19>
          <_StyledDiv20>
            <FooterCopyright />
          </_StyledDiv20>
        </_StyledDiv13>
      </Wrap>
    </_StyledFooter>;
}
var _StyledFooter = /*#__PURE__*/_styled("footer").withConfig({
  componentId: "sc-sf-1ad01bc-0"
})`${p => p.$_css}`;
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-1ad01bc-1"
})`${p => p.$_css2}`;
var _StyledDiv2 = _styled3("div").withConfig({
  componentId: "sc-sf-1ad01bc-2"
})({
  "display": "none",
  "@media (min-width: 1024px)": {
    "display": "block"
  }
});
var _StyledGrid = _styled4(Grid).withConfig({
  componentId: "sc-sf-1ad01bc-3"
})`${p => p.$_css3}`;
var _StyledDiv3 = _styled5("div").withConfig({
  componentId: "sc-sf-1ad01bc-4"
})({
  "gridColumn": "span 3 / span 3",
  "display": "flex",
  "flexDirection": "column"
});
var _StyledDiv4 = _styled6("div").withConfig({
  componentId: "sc-sf-1ad01bc-5"
})`${p => p.$_css4}`;
var _StyledLink = _styled7(Link).withConfig({
  componentId: "sc-sf-1ad01bc-6"
})({
  "width": "100%",
  "maxWidth": "250px"
});
var _StyledDiv5 = _styled8("div").withConfig({
  componentId: "sc-sf-1ad01bc-7"
})`${p => p.$_css5}`;
var _StyledFooterDotGrid = _styled9(FooterDotGrid).withConfig({
  componentId: "sc-sf-1ad01bc-8"
})({
  "position": "absolute",
  "inset": "0"
});
var _StyledDiv6 = _styled10("div").withConfig({
  componentId: "sc-sf-1ad01bc-9"
})({
  "position": "relative",
  "zIndex": "10",
  "marginTop": "auto",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "paddingLeft": "2.4rem",
  "paddingRight": "2.4rem",
  "paddingBottom": "3.6rem"
});
var _StyledDiv7 = _styled11("div").withConfig({
  componentId: "sc-sf-1ad01bc-10"
})`${p => p.$_css6}`;
var _StyledDiv8 = _styled12("div").withConfig({
  componentId: "sc-sf-1ad01bc-11"
})`${p => p.$_css7}`;
var _StyledDiv9 = _styled13("div").withConfig({
  componentId: "sc-sf-1ad01bc-12"
})`${p => p.$_css8}`;
var _StyledDiv10 = _styled14("div").withConfig({
  componentId: "sc-sf-1ad01bc-13"
})({
  "display": "flex",
  "paddingLeft": "8rem",
  "paddingRight": "8rem",
  "paddingTop": "6rem",
  "paddingBottom": "6rem"
});
var _StyledGrid2 = _styled15(Grid).withConfig({
  componentId: "sc-sf-1ad01bc-14"
})`${p => p.$_css9}`;
var _StyledDiv11 = _styled16("div").withConfig({
  componentId: "sc-sf-1ad01bc-15"
})({
  "gridColumn": "span 3 / span 3",
  "display": "flex",
  "height": "100%",
  "alignItems": "center",
  "justifyContent": "center",
  "paddingLeft": "2.4rem",
  "paddingRight": "2.4rem",
  "paddingTop": "2.4rem",
  "paddingBottom": "2.4rem"
});
var _StyledDiv12 = _styled17("div").withConfig({
  componentId: "sc-sf-1ad01bc-16"
})({
  "gridColumn": "span 9 / span 9",
  "display": "flex",
  "height": "100%",
  "alignItems": "center",
  "paddingLeft": "8rem",
  "paddingRight": "8rem",
  "paddingTop": "2.4rem",
  "paddingBottom": "2.4rem"
});
var _StyledDiv13 = _styled18("div").withConfig({
  componentId: "sc-sf-1ad01bc-17"
})`${p => p.$_css10}`;
var _StyledDiv14 = _styled19("div").withConfig({
  componentId: "sc-sf-1ad01bc-18"
})`${p => p.$_css11}`;
var _StyledDiv15 = _styled20("div").withConfig({
  componentId: "sc-sf-1ad01bc-19"
})({
  "display": "flex",
  "height": "100%",
  "width": "7.2rem",
  "flexShrink": "0",
  "alignItems": "center",
  "justifyContent": "center",
  "padding": "1.6rem"
});
var _StyledLink2 = _styled21(Link).withConfig({
  componentId: "sc-sf-1ad01bc-20"
})({
  "width": "100%"
});
var _StyledDiv16 = _styled22("div").withConfig({
  componentId: "sc-sf-1ad01bc-21"
})({
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "center",
  "paddingLeft": "2.4rem",
  "paddingRight": "2.4rem"
});
var _StyledDiv17 = _styled23("div").withConfig({
  componentId: "sc-sf-1ad01bc-22"
})({
  "display": "flex",
  "height": "9.6rem",
  "alignItems": "center",
  "justifyContent": "center",
  "paddingLeft": "1.6rem",
  "paddingRight": "1.6rem"
});
var _StyledDiv18 = _styled24("div").withConfig({
  componentId: "sc-sf-1ad01bc-23"
})({
  "display": "flex",
  "height": "7.2rem",
  "alignItems": "center",
  "justifyContent": "center",
  "paddingLeft": "1.6rem",
  "paddingRight": "1.6rem"
});
var _StyledDiv19 = _styled25("div").withConfig({
  componentId: "sc-sf-1ad01bc-24"
})({
  "paddingLeft": "1.6rem",
  "paddingRight": "1.6rem",
  "paddingTop": "4rem",
  "paddingBottom": "4rem"
});
var _StyledDiv20 = /*#__PURE__*/_styled26("div").withConfig({
  displayName: "app-footer___StyledDiv20",
  componentId: "sc-h9guyp-0"
})({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "paddingLeft": "1.6rem",
  "paddingRight": "1.6rem",
  "paddingTop": "2.4rem",
  "paddingBottom": "2.4rem"
});